const devices_list = [
  {
    id: 1,
    name: "Single Relay",
    img_name: "relay.png",
    description: "Single relay",
    adapter_id: 4,
    adapter_port: 2,
    pinout: { supply: "5V", ground: "GND", signals: ["IN"] },
  },
  {
    id: 2,
    name: "Neopixel (WS2812/SK6812/...)",
    img_name: "neopixel.png",
    description: "Digital RGB LED strip",
    pinout: { supply: "5V", ground: "GND", signals: ["DIN"] },
    adapter_id: null,
    adapter_port: null,
  },
  {
    id: 3,
    name: "DHT11",
    img_name: "dht11.jpg",
    description: "Temperature and humidity sensor",
    pinout: { supply: "3.3V", ground: "GND", signals: ["DATA"] },
    adapter_id: 4,
    adapter_port: 1,
  },
  {
    id: 4,
    name: "DHT22",
    img_name: "dht22.png",
    description: "Temperature and humidity sensor",
    pinout: { supply: "5V", ground: "GND", signals: ["DATA"] },
    adapter_id: 4,
    adapter_port: 1,
  },
  {
    id: 5,
    name: "Buzzer",
    img_name: "buzzer.png",
    description: "Buzzer",
    pinout: { supply: "5V", ground: "GND", signals: ["SIG"] },
    adapter_id: null,
    adapter_port: null,
  },
  {
    id: 6,
    name: "Quad Relay",
    img_name: "quad_relay.jpg",
    description: "Quad relay",
    adapter_id: 1,
    adapter_port: 2,
    pinout: {
      supply: "5V",
      ground: "GND",
      signals: ["IN1", "IN2", "IN3", "IN4"],
    },
  },
  {
    id: 7,
    name: "SSD1306 oled display",
    img_name: "ssd1306.jpeg",
    description: "OLED display",
    pinout: { supply: "3.3V", ground: "GND", signals: ["SCK", "SDA"] },
    adapter_id: 3,
    adapter_port: 1,
  },
  {
    id: 8,
    name: "Rotary encoder",
    img_name: "rotary_encoder.jpg",
    description: "Digital rotary encoder with push button",
    pinout: { supply: "5V", ground: "GND", signals: ["SW", "DT", "CLK"] },
    adapter_id: 2,
    adapter_port: 2,
  },
  {
    id: 9,
    name: "Single button/switch",
    img_name: "single_button.jpg",
    description:
      "This can be a switch or button that you can directly connect with the board",
    pinout: { supply: null, ground: "GND", signals: ["IN"] },
    adapter_id: null,
    adapter_port: null,
  },
  {
    id: 10,
    name: "Double button/switch",
    img_name: "double_button.png",
    description:
      "This can be a switch or button that you can directly connect with the board",
    pinout: { supply: null, ground: "GND", signals: ["IN1", "IN2"] },
    adapter_id: null,
    adapter_port: null,
  },
];

export default devices_list;
